<template>
    <div>
        <b-card class="authentication-method-card text-left">
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center" >
                    <div style="padding-right: 2rem;" v-if="logo">
                        <b-img style="max-width: 70px;" :src="logo"></b-img>
                    </div>
                    <div>
                        <strong>{{ title }}</strong>
                    </div>
                    <div class="ml-4" v-if="currentLoginMethod == lmId">
                        <small>Currently used</small>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                    <div class="connect-error-message" v-if="!connected && !hasUsablePassword && lmType == 'password'">
                        <small>
                            To connect password login please <a :href="setPasswordHref">set a password</a> on your account. 
                        </small>
                    </div>
                    <div class="ml-3">
                        <div v-if="!connected && lmType == 'password'">
                            <b-button :href="connectUrl" v-if="hasUsablePassword" variant="info">Connect</b-button>
                            <b-button disabled v-if="!hasUsablePassword" variant="info">Connect</b-button>
                        </div>
                        <div v-if="!connected && lmType == 'sso_login'">
                            <b-button :href="connectUrl" variant="info">Connect</b-button>
                        </div>
                        <div v-if="connected">

                            <b-button disabled variant="danger" class="ml-2">Disconnect</b-button>
                            <!-- <b-button @click="disconnectLoginMethod" :disabled="currentLoginMethod == lmId" variant="danger" class="ml-2">Disconnect</b-button> -->
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { errorHandling } from '@/js/custom-vue-mixins';

export default {
    name: 'ConnectAuthenticationMethodLine',
    components: {},
    mixins: [errorHandling],
    props: {
        title: {
            type: String,
            default: "Login using default method",
        },
        connectUrl: {
            type: String,
            default: '',
        },
        logo: {
            required: false,
            type: String,
        },
        connected: {
            required: false,
            type: Boolean,
            default: true
        },
        verified: {
            required: true,
            type: Boolean,
        },
        verificationUrl: {
            required: true,
            type: String,
        },
        lmType: {
            required: true,
            type: String,
        },
        hasUsablePassword: {
            required: true,
            type: Boolean,
        },
        tuId: {
            required: true,
            type: String,
        },
        lmId: {
            required: true,
            type: String,
        },
        currentLoginMethod: {
            required: true,
            type: String,
        },
    },
    computed: {
        setPasswordHref() {
            return `/accounts/password/set?next=${window.location.pathname}`
        }
    },
    methods: {
        async disconnectLoginMethod() {
            this.$bvModal.msgBoxConfirm('Are you sure?', {
                title: 'Disconnect login method?',
                size: 'sm',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Yes, disconnect',
                cancelTitle: 'No, Cancel',
                bodyClass: 'text-center',
                headerClass: '',
                footerClass: 'p-2 border-top-0 justify-content-center',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    this.$emit('disconnect-login-method', this.tuId, this.lmId)
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.authentication-method-a {
    color: $black;
}
.authentication-method-a:hover {
    color: $black;
}
.authentication-method-card:hover {
    background-color: $gray-100;
}
</style>
